import React from "react";
import "./advisors.css";
import img1 from "../../images/matangi.jpg";
import img2 from "../../images/esterNew.jpg";
import img3 from "../../images/shyamala1.jpg";
import img4 from "../../images/left-top.png";
import img5 from "../../images/right-bottom.png";
import img6 from "../../images/Renu_Sud_Karnad.jpg";
const icon1 = "https://www.winpeforum.com/assets/elements/shanti.jpg";


export class advisors extends React.Component {
  constructor(args) {
    super(args);
    this.state;
  }

  render() {
    return (
      <div className="section__content">
        <div className="advisors-wrapper" id="advisors">
          <div className="container">
            <div className="advisors-heading">
              <h1>Advisory Board</h1>
            </div>
            <div className="into_text">
              The Winpe ProClub Advisory Board will steer the mentorship program
              in achieving its objectives. We are proud to have the advice and
              guidance from exceptional leaders.
            </div>
            <div className="row card-wrapper justify-content-center">
           
              <div className="col-md-6">
                <div className="card">
                  <div className="top-section">
                    <a href="/matangi-gowrishankar/">
                      <img src={img1} alt="" />
                    </a>
                    <h3>Matangi Gowrishankar</h3>
                    <p className="post">Independent Director</p>
                    <p>Strategic Advisor & Certified Coach </p>
                  </div>
                </div>
              </div>
             <div className="col-md-6">
                <div className="card">
                  <div className="top-section">
                    <a href="/shanti-ekambaram/">
                      <img src={icon1} alt="" />
                    </a>
                    <h3>Shanti Ekambaram</h3>
                    <p className="post">Former Deputy Managing Director & Whole-time Director</p>
                    <p>Strategic Transformation & Governance</p>
                  </div>
                </div>
              </div>
             
            
            </div>
          </div>
        </div>
        
      </div>
    );
  }
}

export default advisors;



// WEBPACK FOOTER //
// ./src/components/advisors/index.jsx